import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { ManagedTransportationMasterServicesAgreement } from '/screens/';

export default function ManagedTransportationMasterServicesAgreementPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics service agreement, managed transportation service agreement,"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Managed Transportation Master Services Agreement"
        description="Managed Transportation Master Services Agreement at Loadsmart"
        canonical="https://loadsmart.com/managed-transportation-master-services-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/managed-transportation-master-services-agreement/',
        }}
      />
      <ManagedTransportationMasterServicesAgreement />
    </>
  );
}
